// extracted by mini-css-extract-plugin
export default {"dropReceiver":"DropReceiver_dropReceiver__G+YzX","withIndicator":"DropReceiver_withIndicator__DSTZv","dropReceiverIndicator":"DropReceiver_dropReceiverIndicator__dLDLO"};